import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogCommentPreStudyReportComponent } from '../dialog-comment-pre-study-report/dialog-comment-pre-study-report.component';
import { MedicalServiceService } from 'src/app/services/medical-service.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-dialog-text-edit',
  templateUrl: './dialog-text-edit.component.html',
  styleUrls: ['./dialog-text-edit.component.css']
})
export class DialogTextEditComponent {

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '18rem',
    minHeight: '5rem',
    translate: 'no',
  };

  constructor(
    public dialogRef: MatDialogRef<DialogTextEditComponent>,
     @Inject(MAT_DIALOG_DATA) public dialogTextEditRequest: DialogTextEditRequest) {
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    this.dialogRef.close( { text: this.dialogTextEditRequest.text } );
  }
}

export interface DialogTextEditRequest {
    text: string;
    textMenu: string;
}

export interface DialogTextEditResponse {
  text: string;
}
